/* eslint-disable */

const start = "@"
const symbols = "[a-zA-Z0-9-_]"

export default {
  signs: new RegExp(start),
  mention: new RegExp(`${start}(${symbols}+)`, "ig"),
}
